// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DummyEditManualPenalty from "./dummy-reponses/DummyEditManualPenalty.bs.js";
import * as PartnerPenaltyRepoConfig from "./PartnerPenaltyRepoConfig.bs.js";
import * as DummyFetchPartnerPenalties from "./dummy-reponses/DummyFetchPartnerPenalties.bs.js";
import * as DummyFetchManualPenaltyList from "./dummy-reponses/DummyFetchManualPenaltyList.bs.js";

function fetchManualPenaltyList(msisdn, order_id, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyFetchManualPenaltyList.successResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.ManualPenaltyListResponseConverter.execute, result);
                            });
                }), "fetchManualPenaltyList");
}

function createManualPenalty(payload, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyEditManualPenalty.successResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.EditManualPenaltyResponseConverter.execute, result);
                            });
                }), "createManualPenalty");
}

function fetchPartnerPenalties(crn, msisdn, start_time, end_time, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyFetchPartnerPenalties.successResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.PartnerPenaltyResponseConverter.execute, result);
                            });
                }), "fetchPartnerPenalties");
}

function deletePartnerPenalty(payload, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: DummyEditManualPenalty.successResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(PartnerPenaltyRepoConfig.EditManualPenaltyResponseConverter.execute, result);
                            });
                }), "deletePartnerPenalty");
}

var PartnerPenaltyRepo = {
  fetchManualPenaltyList: fetchManualPenaltyList,
  createManualPenalty: createManualPenalty,
  fetchPartnerPenalties: fetchPartnerPenalties,
  deletePartnerPenalty: deletePartnerPenalty
};

export {
  PartnerPenaltyRepo ,
  
}
/* NetworkUtils Not a pure module */
